/// <reference types="./connectors.d.mts" />
import * as $endpoints from "../../../app_config/app_config/endpoints.mjs";
import * as $connector from "../../../common/data/connector.mjs";
import * as $confluence from "../../../common/data/connector/confluence.mjs";
import * as $notion from "../../../common/data/connector/notion.mjs";
import * as $salesforce from "../../../common/data/connector/salesforce.mjs";
import * as $connector_settings from "../../../common/data/connector_settings.mjs";
import * as $file_ from "../../../ds/web/browser/file.mjs";
import * as $window from "../../../ds/web/browser/window.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $regexp from "../../../gleam_regexp/gleam/regexp.mjs";
import * as $bit_array from "../../../gleam_stdlib/gleam/bit_array.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $function from "../../../gleam_stdlib/gleam/function.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $uri from "../../../gleam_stdlib/gleam/uri.mjs";
import * as $level from "../../../grille_pain/grille_pain/toast/level.mjs";
import * as $effect from "../../../lustre/lustre/effect.mjs";
import * as $connectors from "../../data/connectors.mjs";
import { Connectors } from "../../data/connectors.mjs";
import * as $state from "../../data/model/state.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $ask from "../../frontend/ask.mjs";
import * as $effects from "../../frontend/effects.mjs";
import * as $error from "../../frontend/error.mjs";
import * as $middleware from "../../frontend/middleware.mjs";
import { Ok, toList, prepend as listPrepend, makeError, divideInt } from "../../gleam.mjs";
import { extract_sitemap } from "./connectors.ffi.ts";

const FILEPATH = "src/frontend/update/connectors.gleam";

function handle_fetch_connector_data(connector) {
  return $middleware.require_access_token(
    (access_token) => {
      return $effect.from(
        (_) => {
          return $function.tap(
            undefined,
            (_) => {
              let _pipe = $ask.to(
                new $ask.Heimdall(),
                toList(["/refresh-data"]),
              );
              let _pipe$1 = $ask.via(_pipe, new $http.Post());
              let _pipe$2 = $ask.bearing(_pipe$1, access_token);
              let _pipe$3 = $ask.query(
                _pipe$2,
                "connector",
                $connector.to_string(connector),
              );
              return $ask.run(_pipe$3);
            },
          );
        },
      );
    },
  );
}

function open_connector_popup(connector, access_token) {
  let connector$1 = $connector.to_string(connector);
  let $ = $uri.parse($endpoints.loki());
  if (!($ instanceof Ok)) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "frontend/update/connectors",
      381,
      "open_connector_popup",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 12863,
        end: 12911,
        pattern_start: 12874,
        pattern_end: 12881
      }
    )
  }
  let uri = $[0];
  let _block;
  let _pipe = $uri.query_to_string(
    toList([["access_token", access_token], ["connector", connector$1]]),
  );
  _block = new $option.Some(_pipe);
  let query = _block;
  let _block$1;
  let _block$2;
  let _record = uri;
  _block$2 = new $uri.Uri(
    _record.scheme,
    _record.userinfo,
    _record.host,
    _record.port,
    uri.path + "/authorize",
    query,
    _record.fragment,
  );
  let _pipe$1 = _block$2;
  _block$1 = $uri.to_string(_pipe$1);
  let uri$1 = _block$1;
  let $1 = [400, 600];
  let width = $1[0];
  let height = $1[1];
  let win = $window.self();
  let left = $window.screen_x(win) + (divideInt(
    ($window.inner_width(win) - width),
    2
  ));
  let top = $window.screen_y(win) + (divideInt(
    ($window.inner_height(win) - height),
    2
  ));
  let _pipe$2 = toList([
    "popup",
    "height=" + $int.to_string(height),
    "width=" + $int.to_string(width),
    "left=" + $int.to_string(left),
    "top=" + $int.to_string(top),
  ]);
  let _pipe$3 = $string.join(_pipe$2, ",");
  let _pipe$4 = ((_capture) => {
    return $window.open(uri$1, "steerlab:connectors:authorize:popup", _capture);
  })(_pipe$3);
  return $result.replace_error(
    _pipe$4,
    new $error.NilError("Opening new window"),
  );
}

function handle_connector_connection(state, connector) {
  return $middleware.require_access_token(
    (access_token) => {
      return $effect.from(
        (dispatch) => {
          if (connector instanceof $connector.GoogleDrive) {
            return undefined;
          } else if (connector instanceof $connector.Confluence) {
            let disabled = $confluence.is_submit_disabled(
              state.connectors.confluence,
            );
            return $bool.guard(
              disabled,
              undefined,
              () => {
                let connector$1 = $connector.to_string(connector);
                let _pipe = $ask.to(new $ask.Loki(), toList(["/api-token"]));
                let _pipe$1 = $ask.via(_pipe, new $http.Post());
                let _pipe$2 = $ask.bearing(_pipe$1, access_token);
                let _pipe$3 = $ask.with$(
                  _pipe$2,
                  $json.object(
                    toList([
                      ["token", $confluence.encode(state.connectors.confluence)],
                      ["connector", $json.string(connector$1)],
                    ]),
                  ),
                );
                let _pipe$4 = $ask.notify(
                  _pipe$3,
                  (_) => {
                    return dispatch(
                      new $msg.ApplicationRequestedFetchUserData(),
                    );
                  },
                );
                $ask.run(_pipe$4)
                return undefined;
              },
            );
          } else if (connector instanceof $connector.Salesforce) {
            let disabled = $salesforce.is_submit_disabled(
              state.connectors.salesforce,
            );
            return $bool.guard(
              disabled,
              undefined,
              () => {
                let connector$1 = $connector.to_string(connector);
                let _pipe = $ask.to(new $ask.Loki(), toList(["/api-token"]));
                let _pipe$1 = $ask.via(_pipe, new $http.Post());
                let _pipe$2 = $ask.bearing(_pipe$1, access_token);
                let _pipe$3 = $ask.with$(
                  _pipe$2,
                  $json.object(
                    toList([
                      ["token", $salesforce.encode(state.connectors.salesforce)],
                      ["connector", $json.string(connector$1)],
                    ]),
                  ),
                );
                let _pipe$4 = $ask.notify(
                  _pipe$3,
                  (_) => {
                    return dispatch(
                      new $msg.ApplicationRequestedFetchUserData(),
                    );
                  },
                );
                $ask.run(_pipe$4)
                return undefined;
              },
            );
          } else if (connector instanceof $connector.Website) {
            return undefined;
          } else if (connector instanceof $connector.Notion) {
            let disabled = $notion.is_submit_disabled(state.connectors.notion);
            return $bool.guard(
              disabled,
              undefined,
              () => {
                let connector$1 = $connector.to_string(connector);
                let _pipe = $ask.to(new $ask.Loki(), toList(["/api-token"]));
                let _pipe$1 = $ask.via(_pipe, new $http.Post());
                let _pipe$2 = $ask.bearing(_pipe$1, access_token);
                let _pipe$3 = $ask.with$(
                  _pipe$2,
                  $json.object(
                    toList([
                      ["token", $notion.encode(state.connectors.notion)],
                      ["connector", $json.string(connector$1)],
                    ]),
                  ),
                );
                let _pipe$4 = $ask.notify(
                  _pipe$3,
                  (_) => {
                    return dispatch(
                      new $msg.ApplicationRequestedFetchUserData(),
                    );
                  },
                );
                $ask.run(_pipe$4)
                return undefined;
              },
            );
          } else if (connector instanceof $connector.OneDrive) {
            let $ = open_connector_popup(connector, access_token);
            
            return undefined;
          } else if (connector instanceof $connector.Slack) {
            let $ = open_connector_popup(connector, access_token);
            
            return undefined;
          } else if (connector instanceof $connector.Steerlab) {
            return undefined;
          } else if (connector instanceof $connector.SteerlabQna) {
            return undefined;
          } else {
            return undefined;
          }
        },
      );
    },
  );
}

function update_connector_settings(state, connector) {
  return $middleware.require_access_token(
    (access_token) => {
      return $middleware.require_org_id(
        state,
        (org_id) => {
          return $effect.from(
            (_) => {
              return $function.tap(
                undefined,
                (_) => {
                  let at = toList([
                    "organizations",
                    org_id,
                    "connectors-settings",
                  ]);
                  let _block;
                  if (connector instanceof $connector.GoogleDrive) {
                    let _pipe = $state.get_google_folder_urls(state);
                    let _pipe$1 = new $connector_settings.GoogleDrive(_pipe);
                    _block = $connector_settings.encode(_pipe$1);
                  } else if (connector instanceof $connector.Confluence) {
                    let _pipe = $state.get_confluence_pages(state);
                    let _pipe$1 = new $connector_settings.Confluence(_pipe);
                    _block = $connector_settings.encode(_pipe$1);
                  } else if (connector instanceof $connector.Website) {
                    let _pipe = $state.get_website_pages(state);
                    let _pipe$1 = new $connector_settings.Website(_pipe);
                    _block = $connector_settings.encode(_pipe$1);
                  } else {
                    _block = $json.null$();
                  }
                  let encoded_connector_settings = _block;
                  let encoded_connector = $connector.encode(connector);
                  let _pipe = $ask.to(new $ask.Heimdall(), at);
                  let _pipe$1 = $ask.via(_pipe, new $http.Post());
                  let _pipe$2 = $ask.with$(
                    _pipe$1,
                    $json.object(
                      toList([
                        ["connector_settings", encoded_connector_settings],
                        ["connector", encoded_connector],
                      ]),
                    ),
                  );
                  let _pipe$3 = $ask.bearing(_pipe$2, access_token);
                  let _pipe$4 = $ask.expect(
                    _pipe$3,
                    $connector_settings.decoder(),
                  );
                  return $ask.run(_pipe$4);
                },
              );
            },
          );
        },
      );
    },
  );
}

function notion_page_regex() {
  let $ = $regexp.from_string(
    "https:\\/\\/www\\.notion\\.so\\/[a-zA-Z0-9_-]+\\/[a-zA-Z0-9_-]+-([a-f0-9]{32})$",
  );
  if (!($ instanceof Ok)) {
    throw makeError(
      "let_assert",
      FILEPATH,
      "frontend/update/connectors",
      449,
      "notion_page_regex",
      "Pattern match failed, no pattern matched the value.",
      {
        value: $,
        start: 14950,
        end: 15087,
        pattern_start: 14961,
        pattern_end: 14966
      }
    )
  }
  let r = $[0];
  return r;
}

function upload_sitemap(sitemap) {
  return $effect.from(
    (dispatch) => {
      return $function.tap(
        undefined,
        (_) => {
          return $promise.map(
            $file_.bytes(sitemap),
            (file_in_bytes) => {
              let file_as_string = $bit_array.to_string(file_in_bytes);
              let urls = extract_sitemap($result.unwrap(file_as_string, ""));
              return dispatch(new $msg.Connectors(new $msg.SitemapParsed(urls)));
            },
          );
        },
      );
    },
  );
}

export function update(state, msg) {
  if (msg instanceof $msg.ApiReturnedConnectorData) {
    let connector = msg[0];
    let connected = msg[1];
    let _pipe = state.connectors.fetched;
    let _pipe$1 = $list.key_set(_pipe, connector, connected);
    let _pipe$2 = ((fetched) => {
      let _record = state.connectors;
      return new Connectors(
        fetched,
        _record.confluence,
        _record.confluence_opened,
        _record.website_opened,
        _record.salesforce,
        _record.salesforce_opened,
        _record.confluence_input_page_url,
        _record.website_input_page_url,
        _record.website_sitemap_pages,
        _record.notion,
        _record.notion_opened,
        _record.google_input_folder_url,
        _record.google_drive_opened,
        _record.settings,
      );
    })(_pipe$1);
    let _pipe$3 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe$2);
    return $pair.new$(_pipe$3, $effect.none());
  } else if (msg instanceof $msg.ApiReturnedConnectorSettings) {
    let settings = msg[0];
    let _block;
    let _record = state.connectors;
    _block = new $connectors.Connectors(
      _record.fetched,
      _record.confluence,
      _record.confluence_opened,
      _record.website_opened,
      _record.salesforce,
      _record.salesforce_opened,
      _record.confluence_input_page_url,
      _record.website_input_page_url,
      _record.website_sitemap_pages,
      _record.notion,
      _record.notion_opened,
      _record.google_input_folder_url,
      _record.google_drive_opened,
      settings,
    );
    let _pipe = _block;
    let _pipe$1 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.UserAddedConfluencePage) {
    let current_pages = $state.get_confluence_pages(state);
    return $bool.guard(
      $list.length(current_pages) >= 50,
      [
        state,
        (() => {
          let _pipe = "Reach out to Steerlab team if you want to add more than 50 pages.";
          return $effects.toast(_pipe, new $level.Error());
        })(),
      ],
      () => {
        let _block;
        let _pipe = listPrepend(
          state.connectors.confluence_input_page_url,
          current_pages,
        );
        let _pipe$1 = $list.unique(_pipe);
        let _pipe$2 = ((_capture) => {
          return $state.set_confluence_pages(state, _capture);
        })(_pipe$1);
        _block = $state.empty_confluence_input_page_url(_pipe$2);
        let updated_state = _block;
        return [
          updated_state,
          update_connector_settings(updated_state, new $connector.Confluence()),
        ];
      },
    );
  } else if (msg instanceof $msg.UserAddedGoogleFolderUrl) {
    let current_folder_urls = $state.get_google_folder_urls(state);
    let more_than_5_folders = $list.length(current_folder_urls) >= 5;
    return $bool.lazy_guard(
      more_than_5_folders,
      () => {
        return [
          state,
          (() => {
            let _pipe = "Reach out to Steerlab team if you want to add more than 5 google folders.";
            return $effects.toast(_pipe, new $level.Error());
          })(),
        ];
      },
      () => {
        let _block;
        let _pipe = listPrepend(
          state.connectors.google_input_folder_url,
          current_folder_urls,
        );
        let _pipe$1 = $list.unique(_pipe);
        let _pipe$2 = ((_capture) => {
          return $state.set_google_folder_urls(state, _capture);
        })(_pipe$1);
        _block = $state.empty_google_input_folder_url(_pipe$2);
        let updated_state = _block;
        return [
          updated_state,
          update_connector_settings(updated_state, new $connector.GoogleDrive()),
        ];
      },
    );
  } else if (msg instanceof $msg.UserAddedWebsitePage) {
    let current_pages = $state.get_website_pages(state);
    return $bool.guard(
      $list.length(current_pages) >= 50,
      [
        state,
        (() => {
          let _pipe = "Reach out to Steerlab team if you want to add more than 50 pages.";
          return $effects.toast(_pipe, new $level.Error());
        })(),
      ],
      () => {
        let _block;
        let _pipe = listPrepend(
          state.connectors.website_input_page_url,
          current_pages,
        );
        let _pipe$1 = $list.unique(_pipe);
        let _pipe$2 = ((_capture) => {
          return $state.set_website_pages(state, _capture);
        })(_pipe$1);
        _block = $state.empty_website_input_page_url(_pipe$2);
        let updated_state = _block;
        return [
          updated_state,
          update_connector_settings(updated_state, new $connector.Website()),
        ];
      },
    );
  } else if (msg instanceof $msg.UserAskedConnectingTo) {
    let connector = msg[0];
    let _pipe = handle_connector_connection(state, connector);
    return ((_capture) => { return $pair.new$(state, _capture); })(_pipe);
  } else if (msg instanceof $msg.UserFetchedConnectorData) {
    let connector = msg[0];
    let _pipe = handle_fetch_connector_data(connector);
    return ((_capture) => { return $pair.new$(state, _capture); })(_pipe);
  } else if (msg instanceof $msg.UserToggledConfluencePanel) {
    let opened = state.connectors.confluence_opened;
    let _block;
    let _record = state.connectors;
    _block = new Connectors(
      _record.fetched,
      _record.confluence,
      !opened,
      _record.website_opened,
      _record.salesforce,
      _record.salesforce_opened,
      _record.confluence_input_page_url,
      _record.website_input_page_url,
      _record.website_sitemap_pages,
      _record.notion,
      _record.notion_opened,
      _record.google_input_folder_url,
      _record.google_drive_opened,
      _record.settings,
    );
    let _pipe = _block;
    let _pipe$1 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.UserToggledGoogleDrivePanel) {
    let opened = state.connectors.google_drive_opened;
    let _block;
    let _record = state.connectors;
    _block = new Connectors(
      _record.fetched,
      _record.confluence,
      _record.confluence_opened,
      _record.website_opened,
      _record.salesforce,
      _record.salesforce_opened,
      _record.confluence_input_page_url,
      _record.website_input_page_url,
      _record.website_sitemap_pages,
      _record.notion,
      _record.notion_opened,
      _record.google_input_folder_url,
      !opened,
      _record.settings,
    );
    let _pipe = _block;
    let _pipe$1 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.UserToggledSalesforcePanel) {
    let opened = state.connectors.salesforce_opened;
    let _block;
    let _record = state.connectors;
    _block = new Connectors(
      _record.fetched,
      _record.confluence,
      _record.confluence_opened,
      _record.website_opened,
      _record.salesforce,
      !opened,
      _record.confluence_input_page_url,
      _record.website_input_page_url,
      _record.website_sitemap_pages,
      _record.notion,
      _record.notion_opened,
      _record.google_input_folder_url,
      _record.google_drive_opened,
      _record.settings,
    );
    let _pipe = _block;
    let _pipe$1 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.UserToggledWebsitePanel) {
    let opened = state.connectors.website_opened;
    let _block;
    let _record = state.connectors;
    _block = new Connectors(
      _record.fetched,
      _record.confluence,
      _record.confluence_opened,
      !opened,
      _record.salesforce,
      _record.salesforce_opened,
      _record.confluence_input_page_url,
      _record.website_input_page_url,
      _record.website_sitemap_pages,
      _record.notion,
      _record.notion_opened,
      _record.google_input_folder_url,
      _record.google_drive_opened,
      _record.settings,
    );
    let _pipe = _block;
    let _pipe$1 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.UserUpdatedConfluenceApiKey) {
    let api_key = msg[0];
    let _block;
    let _record = state.connectors.confluence;
    _block = new $confluence.Token(api_key, _record.domain, _record.user);
    let _pipe = _block;
    let _pipe$1 = ((confluence) => {
      let _record$1 = state.connectors;
      return new Connectors(
        _record$1.fetched,
        confluence,
        _record$1.confluence_opened,
        _record$1.website_opened,
        _record$1.salesforce,
        _record$1.salesforce_opened,
        _record$1.confluence_input_page_url,
        _record$1.website_input_page_url,
        _record$1.website_sitemap_pages,
        _record$1.notion,
        _record$1.notion_opened,
        _record$1.google_input_folder_url,
        _record$1.google_drive_opened,
        _record$1.settings,
      );
    })(_pipe);
    let _pipe$2 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.UserUpdatedConfluenceDomain) {
    let domain = msg[0];
    let _block;
    let _record = state.connectors.confluence;
    _block = new $confluence.Token(_record.api_key, domain, _record.user);
    let _pipe = _block;
    let _pipe$1 = ((confluence) => {
      let _record$1 = state.connectors;
      return new Connectors(
        _record$1.fetched,
        confluence,
        _record$1.confluence_opened,
        _record$1.website_opened,
        _record$1.salesforce,
        _record$1.salesforce_opened,
        _record$1.confluence_input_page_url,
        _record$1.website_input_page_url,
        _record$1.website_sitemap_pages,
        _record$1.notion,
        _record$1.notion_opened,
        _record$1.google_input_folder_url,
        _record$1.google_drive_opened,
        _record$1.settings,
      );
    })(_pipe);
    let _pipe$2 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.UserRemovedConfluencePage) {
    let page_url = msg[0];
    let _block;
    let _pipe = $state.get_confluence_pages(state);
    let _pipe$1 = $list.filter(_pipe, (page) => { return page !== page_url; });
    _block = ((_capture) => {
      return $state.set_confluence_pages(state, _capture);
    })(_pipe$1);
    let updated_state = _block;
    return [
      updated_state,
      update_connector_settings(updated_state, new $connector.Confluence()),
    ];
  } else if (msg instanceof $msg.UserUpdatedSalesforceDomain) {
    let domain = msg[0];
    let _block;
    let _record = state.connectors.salesforce;
    _block = new $salesforce.Token(
      domain,
      _record.client_id,
      _record.client_secret,
    );
    let _pipe = _block;
    let _pipe$1 = ((salesforce) => {
      let _record$1 = state.connectors;
      return new Connectors(
        _record$1.fetched,
        _record$1.confluence,
        _record$1.confluence_opened,
        _record$1.website_opened,
        salesforce,
        _record$1.salesforce_opened,
        _record$1.confluence_input_page_url,
        _record$1.website_input_page_url,
        _record$1.website_sitemap_pages,
        _record$1.notion,
        _record$1.notion_opened,
        _record$1.google_input_folder_url,
        _record$1.google_drive_opened,
        _record$1.settings,
      );
    })(_pipe);
    let _pipe$2 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.UserUpdatedSalesforceClientId) {
    let client_id = msg[0];
    let _block;
    let _record = state.connectors.salesforce;
    _block = new $salesforce.Token(
      _record.domain,
      client_id,
      _record.client_secret,
    );
    let _pipe = _block;
    let _pipe$1 = ((salesforce) => {
      let _record$1 = state.connectors;
      return new Connectors(
        _record$1.fetched,
        _record$1.confluence,
        _record$1.confluence_opened,
        _record$1.website_opened,
        salesforce,
        _record$1.salesforce_opened,
        _record$1.confluence_input_page_url,
        _record$1.website_input_page_url,
        _record$1.website_sitemap_pages,
        _record$1.notion,
        _record$1.notion_opened,
        _record$1.google_input_folder_url,
        _record$1.google_drive_opened,
        _record$1.settings,
      );
    })(_pipe);
    let _pipe$2 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.UserUpdatedSalesforceClientSecret) {
    let client_secret = msg[0];
    let _block;
    let _record = state.connectors.salesforce;
    _block = new $salesforce.Token(
      _record.domain,
      _record.client_id,
      client_secret,
    );
    let _pipe = _block;
    let _pipe$1 = ((salesforce) => {
      let _record$1 = state.connectors;
      return new Connectors(
        _record$1.fetched,
        _record$1.confluence,
        _record$1.confluence_opened,
        _record$1.website_opened,
        salesforce,
        _record$1.salesforce_opened,
        _record$1.confluence_input_page_url,
        _record$1.website_input_page_url,
        _record$1.website_sitemap_pages,
        _record$1.notion,
        _record$1.notion_opened,
        _record$1.google_input_folder_url,
        _record$1.google_drive_opened,
        _record$1.settings,
      );
    })(_pipe);
    let _pipe$2 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.UserRemovedSitemapPage) {
    let page_url = msg[0];
    let _pipe = state.connectors.website_sitemap_pages;
    let _pipe$1 = $list.filter(_pipe, (page) => { return page !== page_url; });
    let _pipe$2 = ((_capture) => {
      return $state.set_sitemap_pages(state, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.UserRequetedSitemapSync) {
    let _block;
    let _pipe = $state.get_website_pages(state);
    let _pipe$1 = $list.append(_pipe, state.connectors.website_sitemap_pages);
    let _pipe$2 = $list.unique(_pipe$1);
    let _pipe$3 = ((_capture) => {
      return $state.set_website_pages(state, _capture);
    })(_pipe$2);
    _block = $state.empty_sitemap_pages(_pipe$3);
    let updated_state = _block;
    return [
      updated_state,
      update_connector_settings(updated_state, new $connector.Website()),
    ];
  } else if (msg instanceof $msg.UserRemovedConnectedWebsitePage) {
    let page_url = msg[0];
    let _block;
    let _pipe = $state.get_website_pages(state);
    let _pipe$1 = $list.filter(_pipe, (page) => { return page !== page_url; });
    _block = ((_capture) => { return $state.set_website_pages(state, _capture); })(
      _pipe$1,
    );
    let updated_state = _block;
    return [
      updated_state,
      update_connector_settings(updated_state, new $connector.Website()),
    ];
  } else if (msg instanceof $msg.UserRemovedGoogleFolderUrl) {
    let page_url = msg[0];
    let _block;
    let _pipe = $state.get_google_folder_urls(state);
    let _pipe$1 = $list.filter(_pipe, (page) => { return page !== page_url; });
    _block = ((_capture) => {
      return $state.set_google_folder_urls(state, _capture);
    })(_pipe$1);
    let updated_state = _block;
    return [
      updated_state,
      update_connector_settings(updated_state, new $connector.GoogleDrive()),
    ];
  } else if (msg instanceof $msg.UserUpdatedConfluencePageInput) {
    let confluence_input_page_url = msg[0];
    let _block;
    let _record = state.connectors;
    _block = new $connectors.Connectors(
      _record.fetched,
      _record.confluence,
      _record.confluence_opened,
      _record.website_opened,
      _record.salesforce,
      _record.salesforce_opened,
      confluence_input_page_url,
      _record.website_input_page_url,
      _record.website_sitemap_pages,
      _record.notion,
      _record.notion_opened,
      _record.google_input_folder_url,
      _record.google_drive_opened,
      _record.settings,
    );
    let _pipe = _block;
    let _pipe$1 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.UserUpdatedWebsitePageInput) {
    let website_input_page_url = msg[0];
    let _block;
    let _record = state.connectors;
    _block = new $connectors.Connectors(
      _record.fetched,
      _record.confluence,
      _record.confluence_opened,
      _record.website_opened,
      _record.salesforce,
      _record.salesforce_opened,
      _record.confluence_input_page_url,
      website_input_page_url,
      _record.website_sitemap_pages,
      _record.notion,
      _record.notion_opened,
      _record.google_input_folder_url,
      _record.google_drive_opened,
      _record.settings,
    );
    let _pipe = _block;
    let _pipe$1 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.UserUpdatedConfluenceUser) {
    let user = msg[0];
    let _block;
    let _record = state.connectors.confluence;
    _block = new $confluence.Token(_record.api_key, _record.domain, user);
    let _pipe = _block;
    let _pipe$1 = ((confluence) => {
      let _record$1 = state.connectors;
      return new Connectors(
        _record$1.fetched,
        confluence,
        _record$1.confluence_opened,
        _record$1.website_opened,
        _record$1.salesforce,
        _record$1.salesforce_opened,
        _record$1.confluence_input_page_url,
        _record$1.website_input_page_url,
        _record$1.website_sitemap_pages,
        _record$1.notion,
        _record$1.notion_opened,
        _record$1.google_input_folder_url,
        _record$1.google_drive_opened,
        _record$1.settings,
      );
    })(_pipe);
    let _pipe$2 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.UserToggledNotionPanel) {
    let opened = state.connectors.notion_opened;
    let _block;
    let _record = state.connectors;
    _block = new Connectors(
      _record.fetched,
      _record.confluence,
      _record.confluence_opened,
      _record.website_opened,
      _record.salesforce,
      _record.salesforce_opened,
      _record.confluence_input_page_url,
      _record.website_input_page_url,
      _record.website_sitemap_pages,
      _record.notion,
      !opened,
      _record.google_input_folder_url,
      _record.google_drive_opened,
      _record.settings,
    );
    let _pipe = _block;
    let _pipe$1 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.UserUpdatedNotionApiKey) {
    let api_key = msg[0];
    let _block;
    let _record = state.connectors.notion;
    _block = new $notion.Token(api_key, _record.page_ids);
    let _pipe = _block;
    let _pipe$1 = ((notion) => {
      let _record$1 = state.connectors;
      return new Connectors(
        _record$1.fetched,
        _record$1.confluence,
        _record$1.confluence_opened,
        _record$1.website_opened,
        _record$1.salesforce,
        _record$1.salesforce_opened,
        _record$1.confluence_input_page_url,
        _record$1.website_input_page_url,
        _record$1.website_sitemap_pages,
        notion,
        _record$1.notion_opened,
        _record$1.google_input_folder_url,
        _record$1.google_drive_opened,
        _record$1.settings,
      );
    })(_pipe);
    let _pipe$2 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.UserUpdatedNotionPageId) {
    let page_ids_str = msg[0];
    let page_ids = $string.split(page_ids_str, ";");
    let re = notion_page_regex();
    let _block;
    let _pipe = page_ids;
    _block = $list.filter(_pipe, (x) => { return x !== ""; });
    let non_empty_page_ids = _block;
    let _block$1;
    let _pipe$1 = non_empty_page_ids;
    let _pipe$2 = $list.filter(_pipe$1, (x) => { return $regexp.check(re, x); });
    _block$1 = $list.length(_pipe$2);
    let nb_valid_inputs = _block$1;
    let $ = nb_valid_inputs === $list.length(non_empty_page_ids);
    if ($) {
      let _block$2;
      let _record = state.connectors.notion;
      _block$2 = new $notion.Token(_record.api_key, page_ids);
      let _pipe$3 = _block$2;
      let _pipe$4 = ((notion) => {
        let _record$1 = state.connectors;
        return new Connectors(
          _record$1.fetched,
          _record$1.confluence,
          _record$1.confluence_opened,
          _record$1.website_opened,
          _record$1.salesforce,
          _record$1.salesforce_opened,
          _record$1.confluence_input_page_url,
          _record$1.website_input_page_url,
          _record$1.website_sitemap_pages,
          notion,
          _record$1.notion_opened,
          _record$1.google_input_folder_url,
          _record$1.google_drive_opened,
          _record$1.settings,
        );
      })(_pipe$3);
      let _pipe$5 = ((_capture) => {
        return $state.set_connectors(state, _capture);
      })(_pipe$4);
      return $pair.new$(_pipe$5, $effect.none());
    } else {
      let _pipe$3 = "Page ids of notion should be seperated by ';'";
      let _pipe$4 = $effects.toast(_pipe$3, new $level.Error());
      return ((_capture) => { return $pair.new$(state, _capture); })(_pipe$4);
    }
  } else if (msg instanceof $msg.UserUpdatedGoogleFolderUrlInput) {
    let google_input_folder_url = msg[0];
    let _block;
    let _record = state.connectors;
    _block = new $connectors.Connectors(
      _record.fetched,
      _record.confluence,
      _record.confluence_opened,
      _record.website_opened,
      _record.salesforce,
      _record.salesforce_opened,
      _record.confluence_input_page_url,
      _record.website_input_page_url,
      _record.website_sitemap_pages,
      _record.notion,
      _record.notion_opened,
      google_input_folder_url,
      _record.google_drive_opened,
      _record.settings,
    );
    let _pipe = _block;
    let _pipe$1 = ((_capture) => {
      return $state.set_connectors(state, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  } else if (msg instanceof $msg.UserUploadedSiteMap) {
    let sitemap = msg.sitemap;
    return [state, upload_sitemap(sitemap)];
  } else {
    let urls = msg.urls;
    let _pipe = urls;
    let _pipe$1 = ((_capture) => {
      return $state.set_sitemap_pages(state, _capture);
    })(_pipe);
    return $pair.new$(_pipe$1, $effect.none());
  }
}
